import React, { Component } from 'react';
import './AlbumsButton.css'
import {Link} from 'react-router-dom'
class PodcastButton extends Component {
    render() {
	return (
	    <Link to={'/albums'}>
		<div className="albumsButton">
		    <div className="content">
			<div className="logo"><img src="/logo-white.svg" alt="Radijski oder" /></div>
			<div className="title">
			    Fotogalerija
			</div>			
		    </div>
		</div>
	    </Link>
	);
    }
}

export default PodcastButton;



// WEBPACK FOOTER //
// ./src/components/AlbumsButton/index.jsx